<template>
  <div>
    <QualificationsLoader v-if="loading" />
    <article id="qualificationsView">
      <header>
        <h2>{{ tdc.tdc_earlyAccessTitle }}</h2>
        <div v-show="qualifiedProducts" class="reserved-4-u" v-html="tdc.tdc_reservedForYouHeader"></div>
        <div v-show="qualifiedProducts" v-html="tdc.tdc_availableSupplies"></div>
      </header>
      <section class="manage-allocations" v-show="Object.keys(qualifications).length > 0 && (totalSharableQty > 0 || canShareBack || totalSharedQty > 0)">
        <div class="line"></div>
        <p class="subhead-l">{{ tdc.tdc_allocationMessage }}</p>
        <button class="hit-outline manager-btn" @click="openManager()" id="manageAllocationsBtn">
          <ns-icon icon-name="icon-product-placeholder-26" /> {{ tdc.tdc_manageButton }}
        </button>
      </section>
      <section>
        <event-countdown :eventName="eventName" />
      </section>
      <ProductList
        v-if="!loading"
        :isTouchDevice="isTouchDevice"
        :products="products"
        :productsInDifferentCountry="productsInDifferentCountry"
        :qualificationLoadError="qualificationLoadError"
        :qualifications="qualifications"
        :qualifiedProducts="qualifiedProducts"
        :tdc="tdc"
        :totalCountriesWithQuantity="totalCountriesWithQuantity"
        v-on:goToHome="goToHome"
      />
      <aside :class="{ fadein: showShareProduct, fadeout: !showShareProduct }" class="slide-up">
        <section class="share-product" :class="{ open: showShareProduct, closed: !showShareProduct, 'gray-bg': showAllocationManager || showTransferStatus || showPartialReturn || showShareProduct }">
          <div class="slide-up-content">
            <PartialReturnApprovalModal
              :cancelText="tdc.tdc_returnAllocationModalCancelText"
              :header="tdc.tdc_returnAllocationModalHeaderText"
              :qualifications="qualifications"
              :returnAmount="returnAmountSelected"
              :returnAllText="tdc.tdc_returnAllocationModalReturnAllText"
              :returnList="partialReturnList"
              :returnSomeText="tdc.tdc_returnAllocationModalReturnSomeText"
              :showReturnAll="showReturnAll"
              :show="showPartialReturnApprovalModal"
              :text="tdc.tdc_returnAllocationModalText"
              v-on:close-return-modal="closeReturnModal"
            />
            <allocation-header
              :qualifications="qualifications"
              :returnAmount="returnAmountSelected"
              :selectedReturns="partialReturnList"
              :subtitle="headerSubtitle"
              :showPartialReturn="showPartialReturn"
              :showFaq="showFaq"
              :faqTitle="tdc.tdc_faq"
              :title="headerTitle"
              v-on:close-share="closeShare()"
              v-on:open-manager="openManager()"
              v-on:open-modal="openReturnModal"
            />
            <div
              v-if="!showFaq"
              class="send-content"
              :class="{ justifyContentCenter: !showTransferItemsInformation }"
            >
              <div class="transfer-items-information-wrapper" v-if="!showAllocationManager && !showTransferStatus && !showPartialReturn && showShareProduct">
                <transfer-items-information />
              </div>
              <div class="divider" v-if="!showAllocationManager && !showTransferStatus && !showPartialReturn && showShareProduct"></div>
              <div class="transfer-display-item transfer-display-search" :class="{'full-width': showAllocationManager || showTransferStatus || showPartialReturn }">
                <manager-options
                  v-if="showAllocationManager"
                  :total-sharable-qty="totalSharableQty"
                  :can-share-back="canShareBack"
                  :total-shared-qty="totalSharedQty"
                  v-on:open-share="openShare()"
                  v-on:open-status="openTransfer()"
                  v-on:open-return="openReturn()"
                />
                <transfer-status
                  v-if="showTransferStatus"
                  v-on:items-reclaimed="getQualifications()"
                  :products="products"
                  :qualifications="qualifications"
                />
                <PartialReturnList
                  v-else-if="showPartialReturn"
                  @update-partial-return-list="handleUpdatePartialReturnList"
                  :partialReturnList="partialReturnList"
                  :qualifications="qualificationsWithReturnableItems"
                  />
                <div v-if="!showAllocationManager && !showTransferStatus && !showPartialReturn && showShareProduct" class="search-wrapper">
                  <h2>{{ tdc.tdc_sendToOthers }}</h2>
                  <div :class="{ 'select-product': selectedDistributor }">
                    <div v-if="!selectedDistributor && showShareProduct">
                      <div style="display:flex;">
                        <div>
                          {{ tdc.tdc_whoToSendTo }}
                        </div>
                        <div
                            v-if="showSearchDisclaimer"
                            @click="openDisclaimer()"
                            style="cursor: pointer;"
                        >
                          <ns-icon
                            icon-name="icon-info"
                            class="nuskin-purple"
                            size="icon-lg"
                          />
                        </div>
                      </div>
                      <distributor-search
                        title
                        :showTransferItemsInformation="showTransferItemsInformation"
                        :label="tdc.tdc_searchLabel"
                        :button-text="tdc.tdc_searchButtonText"
                        :results-text="tdc.tdc_searchResultsText"
                        :search-error="tdc.tdc_searchErrorText"
                        v-model="selectedDistributor"
                        :product="productToBeShared"
                        :qualifications="qualifications"
                        :restrictedMarkets="restrictedMarkets"
                        :info="tdc.tdc_transferMarketRestrictions"
                        @selectedUserOutOfMarket="openOutOfMarket"
                      />
                    </div>
                    <div class="transfer-amount" v-if="selectedDistributor">
                      <div class="share-list">
                        <div class="dist-profile">
                          <div class="distributor-details">
                            <div v-if="selectedDistributor.localName" class="distributor-name">
                              {{ selectedDistributor.localName }}
                            </div>
                            <div v-else class="distributor-name">
                              {{ selectedDistributor.name }}
                            </div>
                          </div>
                        </div>
                        <div>
                          <p class="what-to-send">{{ tdc.tdc_whatToSend }}</p>
                          <div v-for="(product, key) in products" :key="key">
                            <div
                              class="line-item"
                              v-if="qualifications[product.sku] && qualifications[product.sku].sharableQuantity"
                            >
                              <div>
                                <img
                                  v-if="product && product.thumbnail"
                                  height="30"
                                  width="30"
                                  :src="product.thumbnail"
                                />
                                <ns-icon
                                  v-else
                                  icon-name="icon-product-placeholder-26"
                                  size="icon-lg"
                                />
                                <span
                                  v-if="product && product.title"
                                  class="product-title"
                                  v-html="product.title"
                                ></span>
                                <span v-else class="product-title">
                                  Product Name Unavailable
                                </span>
                              </div>
                              <div
                                  v-if="!checkRestrictedMarkets(selectedDistributor.market, product.sku)"
                                  @click="openOutOfMarket(selectedDistributor)"
                                  style="cursor: pointer;"
                              >
                                <ns-icon
                                  icon-name="icon-info"
                                  class="nuskin-purple"
                                  size="icon-lg"
                                />
                              </div>
                              <div v-else>
                                <ns-select
                                  :id="'transferSelect_' + product.sku"
                                  class="qual-qty ns-select"
                                  :items="getQtyOptions(qualifications[product.sku].sharableQuantity)"
                                  :value="0"
                                  @input="$set(sendQty, product.sku, $event)"
                                />
                                <strong>/ {{ qualifications[product.sku].sharableQuantity }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="action-buttons">
                        <button
                          id='transferBtn'
                          :disabled="totalSend === 0 || transferInProgress"
                          class="primary-solid"
                          @click="sendDialog = true"
                        >
                          <CustomSpinner v-if="transferInProgress"/> {{ sendItemsText }}
                        </button>
                        <button
                          id="cancelTransferBtn"
                          class="primary-outline"
                          @click="cancelSend"
                          :disabled="transferInProgress"
                        >
                          {{ tdc.tdc_cancel }}
                        </button>
                        <p v-if="failedToSend" style="margin-top: 10px;" class="error">
                          {{ tdc.tdc_failedToSendQualifications }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showFaq" class="faq" >
              <div class="faqContent" v-html="tdc.tdc_faqContent"></div>
            </div>
          </div>
        </section>
      </aside>
      <v-dialog
        v-model="sendDialog"
        max-width="320"
        content-class="send-dialog send-only-dialog"
        :class="{visible: sendDialog}"
        data-app
      >
        <v-card>
          <v-card-title class="headline">{{ tdc.tdc_sendDialogTitle }}</v-card-title>
          <v-card-text class="content">{{ tdc.tdc_sendDialogMessage }}</v-card-text>
          <v-card-actions>
            <div class="buttons">
              <button
                class="primary-solid send-items-button fluid"
                @click="share"
              >
                {{ sendItemsText }}
              </button>
              <button
                class="primary-outline fluid"
                @click="sendDialog = false"
              >
                {{ tdc.tdc_cancel }}
              </button>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="showOutOfMarketDialog"
        max-width="320"
        content-class="send-dialog out-of-market-dialog"
        :class="{visible: showOutOfMarketDialog}"
        data-app
      >
        <v-card>
          <v-card-title class="headline">{{ tdc.tdc_transferOutOfMarketWarning }}</v-card-title>
          <v-card-text>{{ tdc.tdc_transferOutOfMarketMessage }}</v-card-text>
          <v-card-actions>
            <div class="buttons">
              <button class="primary-outline" @click="showOutOfMarketDialog = false">{{ tdc.tdc_cancel }}</button>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="showDisclaimerDialog"
        max-width="400"
        content-class="send-dialog disclaimer-dialog"
        :class="{visible: showDisclaimerDialog}"
        data-app
      >
        <v-card>
          <v-card-text v-html="tdc.tdc_transferItemsDisclaimer" />
          <v-card-actions>
            <div class="buttons">
              <button class="primary-outline" @click="showDisclaimerDialog = false">{{ closeTxt }}</button>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <section class="actions" v-if="canShareBack && showPurchaseIntent">
        <div class="subhead-l">{{ tdc.tdc_actions }}</div>
        <div class="cards">
          <div class="actions-card">
            <div class="heading-3">
              <ns-icon icon-name="icon-products" size="icon-md" /> {{ tdc.tdc_letUplineKnow }}
            </div>
            <div class="card-content">
              <div class="paragraph-s">{{ tdc.tdc_notCountingAddon }}</div>
              <div class="claim-options">
                <div
                  class="option none"
                  :class="{ selected: optionClaimed === 'NONE' }"
                  @click="setClaimedStatus('NONE')"
                >
                  <ns-icon icon-name="icon-products" size="icon-md" /> <span class="subhead-l">{{ tdc.tdc_none }}</span>
                </div>
                <div
                  class="option partial"
                  :class="{ selected: optionClaimed === 'SOME' }"
                  @click="setClaimedStatus('SOME')"
                >
                  <ns-icon icon-name="icon-products-partial" size="icon-md" /> <span class="subhead-l">{{ tdc.tdc_some }}</span>
                </div>
                <div
                  class="option all"
                  :class="{ selected: optionClaimed === 'ALL' }"
                  @click="setClaimedStatus('ALL')"
                >
                  <ns-icon icon-name="icon-products" size="icon-md" /> <span class="subhead-l">{{ tdc.tdc_all }}</span>
                </div>
              </div>
            </div>
            <div class="option-message paragraph-s" v-if="optionClaimed === 'NONE'">
              <span v-html="noneClaimedMessage" @click="openReturn"></span>
            </div>
            <div class="option-message paragraph-s" v-if="optionClaimed === 'SOME'">
              <span v-html="someClaimedMessage" @click="openReturn"></span>
            </div>
            <div class="option-message paragraph-s" v-if="optionClaimed === 'ALL'">
              <span v-html="tdc.tdc_allClaimedMessage"></span>
            </div>
          </div>
        </div>
      </section>
      <section
        class="other-markets"
        v-show="countries.length > 1 || (productsInDifferentCountry && totalCountriesWithQuantity > 0)"
      >
        <header>
          <div>
            <ns-icon icon-name="icon-info-filled" />
          </div>
          <h3>{{ tdc.tdc_otherMarketsTitle }}</h3>
        </header>
        <div class="content">
          <div class="country-dropdown">
            {{ tdc.tdc_otherMarketsDropdownLabel }}
          </div>
          <div>
            <div class="dropdown">
              <ns-slotted-dropdown
                id="selectOtherCountry"
                tall
                :selected-text="tdc.tdc_selectAMarket"
              >
                <paper-item
                  v-for="(cntry, key) in countries"
                  :key="key"
                  :value="key"
                  v-show="cntry.countryCode !== country"
                  >{{ getCountryName(cntry) }}</paper-item>
              </ns-slotted-dropdown>
            </div>
            <div>
              <button class="primary-solid select-country-button" @click="goToSelectedCountry()">{{ tdc.tdc_goButton }}</button>
            </div>
          </div>
          <div>
            <p>{{ tdc.tdc_otherMarketsDisclaimer }}</p>
          </div>
        </div>
      </section>
      <footer>
        <a href="#" @click="openFaq" class="faqs">{{ tdc.tdc_faq }}</a>
      </footer>
      <ns-toast :opened="qualificationsSent" theme="success">{{tdc.tdc_qualificationsSent }}</ns-toast>
    </article>
    <ExclusiveOfferToast />
    <QualificationTransferToast />
    <ReclaimToast />
    <ReclaimErrorToast />
    <QualificationProductDataLoadingErrorToast />
    <purchase-intent-error />
  </div>
</template>

<script>
import {
  UserService,
} from '@nuskin/ns-account'
import {
  ProductDataService
} from '@nuskin/ns-product'
import {
  events,
  ConfigService,
  MarketSiteRegionsV2,
  RunConfigService,
  StringService,
  util,
} from '@nuskin/ns-util'
import { NsIcon } from '@nuskin/ns-icon'
import { NsSelect } from '@nuskin/design-components'

import AllocationHeader from '../components/AllocationHeader.vue'
import CustomSpinner from '../components/CustomSpinner.vue'
import EventCountdown from '../components/events/EventCountdown.vue'
import ExclusiveOfferToast from '../components/toasts/ExclusiveOfferToast.vue'
import ManagerOptions from '../components/ManagerOptions.vue'
import NsDistributorSearch from '../components/ns-distributor-search.vue'
import PartialReturnApprovalModal from '../components/partialReturn/PartialReturnApprovalModal.vue'
import PartialReturnList from '../components/partialReturn/PartialReturnList.vue'
import ProductList from '../components/products/ProductList.vue'
import PurchaseIntentError from '../components/toasts/PurchaseIntentError.vue'
import QualificationProductDataLoadingErrorToast from '../components/toasts/QualificationProductDataLoadingErrorToast.vue'
import QualificationsLoader from '../components/QualificationsLoader.vue'
import QualificationTransferToast from '../components/toasts/QualificationTransferToast.vue'
import ReclaimErrorToast from '../components/toasts/QualificationReclaimErrorToast.vue'
import ReclaimToast from '../components/toasts/QualificationReclaimToast.vue'
import TransferItemsInformation from '../components/TransferItemsInformation.vue'
import TransferStatus from '../components/TransferStatus.vue'

import config from '../js/qualificationsConfigService'

export default {
  components: {
    AllocationHeader,
    CustomSpinner,
    DistributorSearch: NsDistributorSearch,
    EventCountdown,
    ExclusiveOfferToast,
    ManagerOptions,
    NsIcon,
    NsSelect,
    PartialReturnApprovalModal,
    PartialReturnList,
    ProductList,
    PurchaseIntentError,
    QualificationProductDataLoadingErrorToast,
    QualificationsLoader,
    QualificationTransferToast,
    ReclaimErrorToast,
    ReclaimToast,
    TransferItemsInformation,
    TransferStatus,
  },
  data() {
    return {
      addToCart: '',
      allCountries: [],
      availableCountries: [],
      back: '',
      close: '',
      country: RunConfigService.getRunConfig().country,
      failedToSend: false,
      isTouchDevice: util.MobileUtils.isMobileLike(),
      language: RunConfigService.getRunConfig().language,
      loading: true,
      optionClaimed: '',
      partialReturnList: {},
      products: [],
      productToBeShared: null,
      qualificationLoadError: false,
      qualifications: {},
      qualificationsSent: false,
      qualificationsWithReturnableItems: [],
      regionList: [],
      restrictedMarkets: {},
      returnAmountSelected: 0,
      returnSku: null,
      selectedCountryLocale: '',
      selectedDistributor: null,
      selectedQty: 1,
      sendDialog: false,
      sendQty: {},
      showAllocationManager: false,
      showDisclaimerDialog: false,
      showFailedCartAdd: false,
      showFaq: false,
      showOutOfMarketDialog: false,
      showPartialReturn: false,
      showPartialReturnApprovalModal: false,
      showPurchaseIntent: false,
      showReturnAll: false,
      showSearchDisclaimer: false,
      showShareProduct: false,
      showTransferItemsInformation: `${config.showTransferItemsInformation}` == true,
      showTransferStatus: false,
      tdc: config.getTdc(),
      totalCountriesWithQuantity: 0,
      totalSharableQty: 0,
      totalSharedQty: 0,
      transferInProgress: false,
    }
  },
  mounted() {
    if (config && config.getConfig() && config.getConfig().products) {
      this.products = config.getConfig().products
    }

    // If not logged in don't do anything we will get redirected to login
    if (UserService.isLoggedIn()) {
      this.getAllCountries()
      this.setCommonStrings()
      this.getProductInfo()
      this.getQualifications()

      const selectOtherCountry = document.getElementById('selectOtherCountry')
      if (selectOtherCountry) {
        selectOtherCountry.addEventListener('nsDropdownSelect', (e) => {
          this.setSelectedCountry(e.detail.index)
        })
      }

      events.subscribe(events.shop.QUALIFICATION_STATUS_CHANGED, () => {
        this.getQualifications()
      })
    } else {
      // Check to see if we are logged in and redirect to login page
      events.publish(events.authentication.REQUEST_FOR_LOGIN)
    }

    const salesEventConfig = ConfigService.getMarketConfig().salesEventConfiguration
    const showSearchDisclaimer = salesEventConfig.showTransferDisclaimer
    if (showSearchDisclaimer) {
      this.showSearchDisclaimer = true
    }
    const showPurchaseIntent = salesEventConfig.togglePurchaseIntent
    if (showPurchaseIntent) {
      this.showPurchaseIntent = true
    }
  },
  computed: {
    headerTitle() {
      let title = ''
      if (this.showAllocationManager) {
        title = this.tdc.tdc_allocationManagerTitle
      } else if (this.showTransferStatus) {
        title = this.tdc.tdc_transferStatusPageTitle
      } else if (this.showShareProduct) {
        title = this.tdc.tdc_transferItemsTitle
      } else if (this.showPartialReturn) {
        title = this.getTdcString('tdc_partialReturnHeaderTitleText', 'Return Your Allocation')
      }

      return title
    },
    headerSubtitle() {
      let subtitle = ''
      if (this.showAllocationManager) {
        subtitle = this.tdc.tdc_allocationManagerText
      } else if (this.showTransferStatus) {
        subtitle = this.tdc.tdc_transferStatusPageText
      } else if (this.showPartialReturn) {
        subtitle = this.getTdcString('tdc_partialReturnHeaderText', 'Transfer your allocation back to your Sales Leader.')
      } else if (this.showShareProduct) {
        subtitle = this.tdc.tdc_transferItemsMessage
      }

      return subtitle
    },
    canShareBack() {
      return this.qualifications && Object.values(this.qualifications)
        .map((qualification) => qualification.shareBackList)
        .flat()
        .filter((shareBackItem) => shareBackItem.quantity > 0)
        .length > 0
    },
    totalSend() {
      let total = 0
      Object.values(this.sendQty).forEach((qty) => {
        total += qty
      })
      return total
    },
    sendItemsText() {
      return this.tdc.tdc_sendItemsButtonText.replace('{numItems}', this.totalSend)
    },
    qualifiedProducts() {
      if (!Array.isArray(this.products)) {
        return false // this will happen if the market has not configured any products for the event
      }

      const qualItems = this.products.filter((product) => {
        return (
          this.qualifications[product.sku] &&
          this.qualifications[product.sku].quantity > 0
        )
      })

      return qualItems.length > 0
    },

    eventName() {
      const qual = Object.values(this.qualifications).find((qual) => !!qual.eventName)
      return qual ? qual.eventName : null
    },

    countries() {
      return this.allCountries.filter((cntry) => {
        return this.availableCountries.includes(cntry.countryCode)
      })
    },
    productsInDifferentCountry() {
      let productsInDifferentCountry = false
      if (this.countries.length === 1) {
        if (this.countries[0].countryCode !== this.country) {
          productsInDifferentCountry = true
        }
      }

      return productsInDifferentCountry
    },
    noneClaimedMessage() {
      return this.tdc.tdc_noneClaimedMessage.replace('{returnUnclaimed}', `<a @click="openReturn">${this.tdc.tdc_returnUnclaimed}</a>`)
    },
    someClaimedMessage() {
      return this.tdc.tdc_someClaimedMessage.replace('{returnUnclaimed}', `<a @click="openReturn">${this.tdc.tdc_returnUnclaimed}</a>`)
    },
  },
  methods: {
    qualificationEventName(qualification) {
      return qualification ? qualification.eventName : null
    },

    closeAll(overrides={}) {
      this.showShareProduct = overrides.showShareProduct || false
      this.showAllocationManager = overrides.showAllocationManager || false
      this.showPartialReturn = overrides.showPartialReturn || false
      this.showTransferStatus = overrides.showTransferStatus || false
      this.showFaq = overrides.showFaq || false
    },
    getQtyOptions(qty) {
      return [...Array(qty + 1).keys()]
    },
    openManager() {
      if (this.showAllocationManager) {
        this.closeShare()
      } else {
        this.closeAll({
          showShareProduct: true,
          showAllocationManager: true,
        })
        this.clearSendQty()
        this.partialReturnList = {}
        this.returnAmountSelected = 0
        document.documentElement.classList.add('no-scroll')
      }
    },
    openReturn() {
      this.closeAll({
        showShareProduct: true,
        showPartialReturn: true,
      })
    },
    openReturnModal(data) {
      this.showReturnAll = data && data.type === 'all'
      this.showPartialReturnApprovalModal = true
    },
    openTransfer() {
      this.closeAll({
        showShareProduct: true,
        showTransferStatus: true,
      })
    },
    openShare() {
      this.closeAll({ showShareProduct: true })
      document.documentElement.classList.add('no-scroll')
    },
    clearSendQty() {
      Object.keys(this.sendQty).forEach((key) => {
        this.$set(this.sendQty, key, 0)
      })
    },
    closeReturnModal({ returnItems } = { returnItems: 'none' }) {
      this.showPartialReturnApprovalModal = false
      if (returnItems === 'all') {
        this.closeShare()
      } else if (returnItems === 'selected') {
        this.resetReturnSelections()
        this.returnAmountSelected = 0
      }
    },
    closeShare() {
      this.closeAll()
      this.clearSendQty()
      this.partialReturnList = {}
      this.returnAmountSelected = 0
      this.productToBeShared = null
      this.selectedDistributor = null
      document.documentElement.classList.remove('no-scroll')
    },
    resetReturnSelections() {
      this.partialReturnList = {}
    },
    openFaq() {
      this.openShare()
      this.showFaq = true
    },
    setCommonStrings() {
      const commonStrings = [{ key: 'addToCart', dflt: 'Add to cart' }, { key: 'close', dflt: 'Close' }]
      StringService.getStrings(commonStrings).then((strings) => {
        this.addToCart = strings.addToCart
        this.closeTxt = strings.close
      })
    },
    getTdcString(key, stringDefault) {
      if (this.tdc && this.tdc[key] && this.tdc[key] !== 'undefined') {
        return this.tdc[key]
      }
      return stringDefault
    },
    getProductInfo() {
      const productSkus = this.products.map(item => item.sku)
      const locale = `${this.language}_${this.country}`
      ProductDataService.getProductData(productSkus, locale)
        .then(({ products }) => {
          this.products = products
        })
    },
    goToSelectedCountry() {
      window.location.href = this.selectedCountryLocale
    },
    initClaimedStatus() {
      const statusMap = Object.values(this.qualifications).reduce((map, qual) => {
        map[qual.claimStatus || 'NO-RESPONSE'] = qual.claimStatus || ''
        return map
      }, [])

      const statuses = Object.values(statusMap)
      this.optionClaimed = statuses.length === 1 && statuses[0] !== 'NO-RESPONSE' ? statuses[0] : ''
    },
    async setClaimedStatus(option) {
      const claimArray = []
      const status = this.optionClaimed != option ? option : 'NO-RESPONSE'

      this.optionClaimed = status === 'NO-RESPONSE' ? '': option
      Object.values(this.qualifications).forEach((qual) => {
        qual.shareBackList.forEach((item) => {
          claimArray.push({
            sku: qual.sku,
            customerId: item.customerId,
            status: status,
          })
        })
      })

      if (claimArray.length > 0) {
        const evn = events
        try {
          await aem.QualificationService.claimQualifications(claimArray)
        } catch (e) {
          evn.publish('purchaseIntentError')
          this.optionClaimed = ''
        }
      }
    },
    setRestrictedMarkets(qualifications) {
      const restrictions = {}
      for (const sku of Object.keys(qualifications)) {
        this.products.forEach((obj) => {
          if (obj.restrictedMarkets && obj.sku === sku) {
            restrictions[obj.sku] = obj.restrictedMarkets
          }
        })
      }
      this.restrictedMarkets = restrictions
    },
    setSelectedCountry(index) {
      if (this.countries.length > 0) {
        const selectedCountry = this.countries[index]
        let languageCode
        if (selectedCountry.languageCodes.includes(this.language)) {
          languageCode = this.language
        } else {
          languageCode = selectedCountry.languageCodes[0]
        }
        const homePath = selectedCountry.paths[languageCode]
        this.selectedCountryLocale = homePath.replace(
          'home',
          'exclusive-offer',
        )
      }
    },
    getAllCountries() {
      MarketSiteRegionsV2.getMarketSiteRegionData().then((regions) => {
        regions.forEach((region) => {
          const countryList = region.countryname
          countryList.forEach((cntry) => {
            this.allCountries.push(cntry)
          })
        })
      })
    },
    getCountryName(country) {
      return country.locale_names[this.language]
    },
    setCountryDropdown(qualifications) {
      const countryKeys = Object.keys(qualifications).map((sku) => {
        return qualifications[sku].markets
      })

      const combinedCntryList = []
      countryKeys.forEach((market) => {
        market.forEach((mkt) => {
          combinedCntryList.push(mkt)
        })
      })

      const shortenedList = []
      combinedCntryList.forEach((cntry) => {
        if (!shortenedList.includes(cntry)) {
          shortenedList.push(cntry)
        }
      })

      let totalCountriesWithQuantity = 0
      const countryChecked = []
      shortenedList.forEach((cntryCd) => {
        Object.keys(qualifications).forEach((sku) => {
          if (qualifications[sku].markets.includes(cntryCd)) {
            if (!countryChecked.includes(cntryCd)) {
              if (qualifications[sku].quantity > 0 || qualifications[sku].sharedList.length > 0) {
                countryChecked.push(cntryCd)
                totalCountriesWithQuantity++
              }
            }
          }
        })
      })

      this.availableCountries = countryChecked
      this.totalCountriesWithQuantity = totalCountriesWithQuantity
      this.setSelectedCountry(0)
    },

    setQualifications(qualifications) {
      // check for errors loading qualifications
      const hasErrorQualifications = Object.keys(qualifications)
        .filter(sku => qualifications[sku].addOns)
        .filter(sku => qualifications[sku].addOns.errorMessage)
        .length > 0

      if (hasErrorQualifications && !this.hasErrorQualifications) {
        this.hasErrorQualifications = true
        events.publish('qualificationProductDataLoadingError')
      }

      // get the list of addOn skus
      const addOnSkuList = Object.keys(qualifications)
        .filter(sku => qualifications[sku].addOns)
        .filter(sku => !qualifications[sku].addOns.errorMessage)
        .map(sku => qualifications[sku].addOns)
        .flat()

      // nest the addOns into their parents
      Object.keys(qualifications)
        .forEach(sku => {
          const newAddOnsField = {}
          if (qualifications[sku].addOns && !qualifications[sku].addOns.errorMessage) {
            qualifications[sku].addOns.forEach(addOnSku => {
              if (qualifications[addOnSku]) {
                newAddOnsField[addOnSku] = qualifications[addOnSku]
              }
            })
          }
          qualifications[sku].addOns = newAddOnsField
        })

      // Add the isAddOn flag to the main qualification list
      addOnSkuList.forEach(sku => {
        if (qualifications[sku]) {
          qualifications[sku].isAddOn = true
        }
      })
      this.qualifications = qualifications
      this.totalSharableQty = 0
      this.totalSharedQty = 0
      this.qualificationsWithReturnableItems = []
      this.initClaimedStatus()
      this.sendQty = {}
      Object.keys(this.qualifications).forEach((key) => {
        if (this.qualifications[key].sharableQuantity > 0) {
          this.$set(this.sendQty, key, 0)
        }
        if (this.qualifications[key].shareBackList && this.qualifications[key].shareBackList.length > 0) {
          const product = this.products.find((product) => product.sku === key)
          if (product) {
            qualifications[key]['thumbnail'] = product.thumbnail
            qualifications[key]['title'] = product.title
          }
          let totalAllocations = 0
          this.qualifications[key].shareBackList.forEach((element) => {
            totalAllocations += element.quantity
          })
          if (totalAllocations > 0) {
            this.qualificationsWithReturnableItems.push(this.qualifications[key])
          }
        }
        this.totalSharableQty += this.qualifications[key].sharableQuantity
        this.totalSharedQty += this.qualifications[key].sharedList.reduce((cnt, sharedItem) => {
          cnt += sharedItem.quantity
          return cnt
        }, 0)
      })
      this.setRestrictedMarkets(qualifications)
      this.loading = false
    },

    checkRestrictedMarkets(market, sku) {
      if (this.restrictedMarkets && Array.isArray(this.restrictedMarkets[sku]) && this.restrictedMarkets[sku].includes(market)) {
        return false
      }
      return true
    },

    async getQualifications() {
      try {
        const response = await aem.QualificationService.getQualifications()
        // filter user's qualifications down to what's on this page
        const qualifications = Object.values(response)
          .reduce((map, qual) => {
            if (this.products.some((product) => product.sku === qual.sku)) {
              map[qual.sku] = qual
            }
            return map
          }, {})

        const otherMarkets = Object.values(response)
          .reduce((map, qual) => {
            if (this.products.some((product) => product.sku !== qual.sku)) {
              map[qual.sku] = qual
            }
            return map
          }, {})
        this.setQualifications(qualifications)
        this.setCountryDropdown(otherMarkets)
        aem.QualificationService.qualificationsViewed(Object.keys(qualifications))
      } catch (e) {
        events.publish('qualificationLoadingError')
        this.loading = false
        this.qualificationLoadError = true
      }
    },

    share() {
      this.transferInProgress = true
      this.sendDialog = false
      this.failedToSend = false
      const transfers = []
      Object.keys(this.sendQty).forEach((key) => {
        if (this.sendQty[key] > 0) {
          const transfer = {
            customerId: this.selectedDistributor.sapId,
            sku: key,
            quantity: this.sendQty[key],
          }
          transfers.push(transfer)
        }
      })
      aem.QualificationService.transferQualifications(transfers, true)
        .then((response) => {
          this.setQualifications(response.qualifications)
          events.publish(
            events.shop.QUALIFICATION_SENT,
            response.qualifications,
          )
          this.closeShare()
          this.transferInProgress = false
          const emailErrorMsg = response.messages.find(
            (msg) => msg.type === 'EmailError',
          )
          if (emailErrorMsg) {
            events.publish(
              events.shop.QUALIFICATION_SENT_EMAIL_FAILED,
              emailErrorMsg.message,
            )
          } else {
            this.showQualificationSentToast()
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err)
          this.sendDialog = false
          this.transferInProgress = false
          this.failedToSend = true
        })
    },
    cancelSend() {
      this.selectedDistributor = null
      this.clearSendQty()
    },
    goToHome() {
      window.location = util.getLocaleUrl() + 'home.html'
    },
    showQualificationSentToast() {
      this.qualificationsSent = true
      // Show the successful qualifications sent toast for 3 seconds
      setTimeout(() => {
        this.qualificationsSent = false
      }, 3000)
    },
    openOutOfMarket(personObject) {
      this.showOutOfMarketDialog = true
    },
    openDisclaimer(personObject) {
      this.showDisclaimerDialog = true
    },
    handleUpdatePartialReturnList(list) {
      this.partialReturnList = {
        ...this.partialReturnList,
        ...list,
      }
      this.calculateTotalSelected()
    },
    calculateTotalSelected() {
      const skus = Object.keys(this.partialReturnList)
      if (skus.length === 0) {
        return false
      }
      const totalSelected = skus
        .map((sku) => this.partialReturnList[sku])
        .map(Object.values)
        .flat()
        .reduce((a, b) => a + b)
      this.returnAmountSelected = totalSelected
    },
  },
}
</script>

<style lang="scss">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typography";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

$shells: map.get(colors.$baseColors, "shells");
$steel: map.get(colors.$baseColors, "steel");
$eyore: map.get(colors.$baseColors, "eyore");
$white: map.get(colors.$baseColors, "basewhite");
$blackhole: map.get(colors.$baseColors, "blackhole");

#mainContainer {
  background: linear-gradient(to bottom right, #bd2687, #324366);
  max-width: 100%;
}

.nuskin-purple {
  color: #7123d9;
}

#qualificationsView {
  padding: 40px 0;
  font-family: "proxima-nova";

  .slide-up .slide-up-content {
    h2 {
      color: $blackhole;
      @include global.heading-1();
      text-align: left;
    }

    header {
      p {
        @include global.paragraph-m();
        text-align: left;
        color: $blackhole;
        height: auto;
      }
    }
  }

  .v-select__selection--comma,
  .v-select__slot .v-input__append-inner {
    z-index: 100 !important;
  }

  .v-select__slot .v-select__selections .v-select__selection--comma {
    left: 10px;
  }

  .v-text-field__details {
    display: none;
  }
  .actions {
    display: flex;
    justify-content: center;
    flex-direction: column;

    .subhead-l {
      color: #ffffff;
      margin-bottom: 20px;
    }

    .cards {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }

    .actions-card {
      background-color: #ffffff;
      border: 1px solid #BBBCBC;
      box-sizing: border-box;
      box-shadow: 0px 5px 14px rgba(0, 0, 0, 0.12), 0px 9px 10px rgba(0, 0, 0, 0.14), 0px 0px 5px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      min-width: 300px;
      min-height: 200px;
      max-width: 345px;
      padding: 20px 15px;
      text-align: left;

      a {
        color: map.get(colors.$baseColors, "shells");
        display: block;
      }

      .magic {
        color: map.get(colors.$baseColors, "magic");
        font-weight: 600;
      }

      .heading-3 {
        display: flex;

        .icon {
          margin-right: 10px;
        }
      }

      .card-content {
        padding: 0 30px;

        .paragraph-s {
          padding-bottom: 5px;
        }
      }

      .option-message.paragraph-s {
        padding: 15px 0 0 30px;
      }
    }

    .claim-options {
      display: flex;
      justify-content: space-between;


      .option {
        border: 2px solid map.get(colors.$baseColors, "shells");
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: map.get(colors.$baseColors, "shells");
        border-radius: 6px;
        height: 75px;
        width: 65px;
        cursor: pointer;


        &.none {
          color: map.get(colors.$baseColors, "gandalf");
        }

        &.selected,
        &:hover {
          background-color: map.get(colors.$baseColors, "shells");
          color: #ffffff;

          &.none {
            color: map.get(colors.$baseColors, "ash");
          }

          &.partial {
            .icon g > path:first-child {
              stroke: map.get(colors.$baseColors, "eyore");
            }
          }

          .subhead-l {
            color: #ffffff;
          }
        }

        .icon {
          align-self: center;
        }

        .subhead-l {
          color: #7123D9;
          margin-bottom: 0;
          text-align: center;
        }
      }
    }
  }
}

#qualificationsView header,
footer {
  text-align: center;
  color: white;
  padding-bottom: 10px;
}

footer .faqs {
  font-size: 16px;
}

#qualificationsView header h2,
#qualificationsView header p {
  color: white;
}

#qualificationsView header h2 {
  font-size: 22px;
  line-height: 27px;
  margin-bottom: 5px;
  font-weight: var(--font-weight-bold);
  font-family: var(--font-family-primary);
}

#qualificationsView header p {
  color: white;
  font-size: 13px;
  font-weight: var(--font-weight-normal);
  text-align: center;
  letter-spacing: 0.1px;
  line-height: 16px;
}

#qualificationsView hr {
  border-top-width: 2px;
  width: 245px;
  margin: 20px auto;
}

#qualificationsView a {
  color: white;
  text-decoration: underline;
}

#qualificationsView .other-markets {
  background: white;
  border-top: 8px solid var(--notice-color);
  width: 860px;
  max-width: 100%;
  margin: 0 auto 20px;
  padding: 10px 0;
  box-sizing: border-box;
}

#qualificationsView .other-markets header {
  display: flex;
}

#qualificationsView .other-markets .icon {
  color: var(--notice-color);
  margin-right: 5px;
  height: 28px;
  width: 28px;
}

#qualificationsView .other-markets .content,
#qualificationsView .other-markets .content > div {
  display: flex;
  width: 48%;
  justify-content: space-between;
  align-items: center;
}

#qualificationsView .other-markets .content > div.country-dropdown {
  display: none;
  font-size: 16px;
  font-weight: var(--font-weight-normal);
  line-height: 22px;
  margin-bottom: 5px;
  color: var(--blackhole);
}

#qualificationsView .other-markets .content > div .dropdown {
  flex-grow: 1;
}

#qualificationsView .other-markets header {
  width: 800px;
  max-width: 100%;
  margin: auto;
  text-align: left;
  margin-bottom: 10px;
}

#qualificationsView .other-markets header h3 {
  line-height: 24px;
  font-size: 18px;
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-family-primary);
}

#qualificationsView .other-markets .content {
  width: 740px;
  max-width: 100%;
  margin: 0 auto 10px;
}

#qualificationsView .other-markets ns-slotted-dropdown {
  margin-right: 6px;
}

#qualificationsView .other-markets p {
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  line-height: 18px;
}

.reserved-4-u {
  margin: 0 auto;
  max-width: 61vw;
  color: white;
  font-size: 14px;
  font-weight: var(--font-weight-normal);
  text-align: center;
  letter-spacing: 0px;
  line-height: 18px;
  margin-bottom: 12px;
}

v-avatar {
  display: inline-block;
}

.no-scroll {
  overflow: hidden;
}

.profile-icon {
  height: 48px;
  width: 48px;
}

.distributor-details {
  display: inline-block;
  margin-top: 30px;
  vertical-align: middle;
  min-height: 48px;
  color: var(--blackhole);
}

.ns-select ::-webkit-scrollbar {
  display: block;
  -webkit-appearance: none;
  width: 7px;
}

.ns-select ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

.ns-select .v-menu__content.menuable__content__active {
  background: white;
}

::-webkit-scrollbar {
  display: none;
}

.scrollable {
  width: 100%;
  overflow: auto;
}

.scrollable > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.scrollable.select-product {
  height: calc(100% - 70px);
  height: 100%;
}

.dropdown-body {
  max-height: 250px;
  overflow: auto;
}

.search-wrapper, .transfer-items-information-wrapper {
  padding-top: 20px;
}

.sponsor-search {
  max-width: 400px;
}

.sponsor-name {
  font-family: proxima-nova !important;
}

.sponsor-search-result-error {
  margin-top: 15px;
}

.distributor-name {
  font-size: 16px;
  font-weight: bold;
}

.distributor-details .distributor-name {
  font-family: proxima-nova;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
}

.allocation-manager {
  h2 {
    margin-bottom: 20px;
  }
}

.manage-allocations {
  margin: 0 auto 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 395px;
  padding: 0 15px;

  .line {
    width: 164px;
    height: 1px;
    border-top: 1px solid $white;
    align-self: center;
    margin-bottom: 20px;
  }

  .subhead-l {
    color: $white;
    text-align: center;
    margin-bottom: 10px;
  }

  .manager-btn:hover {
    background-color: rgb(221, 221, 221);
    color: #7123d9;
  }
}

.allocation-options {
  .options {
    display: flex;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    border: 1px solid map.get(colors.$baseColors, "gandalf");
    border-radius: 6px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;
    max-width: 450px;
    background-color: $white;

    &> div:first-child {
      min-width: 20px;
      margin-right: 14px;
    }

    &.disabled-option {
      color: $eyore;
      cursor: not-allowed;
      pointer-events: none;
      box-shadow: none;

      .icon, h3, p {
        color: $eyore;
      }
    }
  }
  .icon {
    color: $shells;
    height: 20px;
    width: 20px;
  }

  h3  {
    color: $shells;
    @include global.heading-3();
  }
}

.error {
  color: var(--redshirt);
}

.line-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
  color: var(--blackhole);
}

.line-item > div {
  display: flex;
  align-items: center;
}

.line-item .ns-select {
  margin-right: 5px;
}

.line-item strong {
  color: var(--blackhole);
  white-space: nowrap;
}

.product-title {
  line-height: 17px;
  vertical-align: middle;
  margin-left: 15px;
}

.action-buttons {
  bottom: 60px;
  display: flex;
  flex-direction: column;
  margin-top: 35px;
  width: 100%;
  background-color: white;
}

.slide-up {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.56);
  z-index: var(--z-drawer);
}

.slide-up.fadeout {
  visibility: hidden;
  animation: fadeOut 0.35s ease;
}

.slide-up.fadein {
  visibility: visible;
  animation: fadeIn 0.35s ease;
}

.slide-up section.share-product {
  background: #ffffff;
  width: 100%;
  height: 100%;
  top: 100%;
  max-height: 0;
  position: fixed;

  header {
    padding: 20px;
  }

  &.gray-bg {
    background-color: map.get(colors.$baseColors, "gandalfthewhite");

    header {
      background-color: $white;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    }

    .send-content {
      width: calc(100% - 40px);
      margin: 0 auto;
      height: 100%;
    }
  }
}

.slide-up .section.share-product.closed {
  top: 100%;
  height: 100%;
  max-height: 0;
  animation: slideDown 0.35 ease;
  transition: all 0.25s ease-in-out;
}

.slide-up section.share-product.open {
  max-height: 100%;
  top: 0;
  height: 100%;
  animation: slideUp 0.35s ease;
  overflow: auto;
}

.slide-up .slide-up-content {
  max-width: 100%;
  margin: auto;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.slide-up .slide-up-content .close-slide-up-container {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;

  .back-link {
    color: $shells;
  }
}

.slide-up .slide-up-content h2 {
  @include global.heading-1();
}

.what-to-send {
  font-size: 16px;
  font-weight: 600;
}

.send-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 0px;
  overflow: auto;
}

.send-dialog.visible .v-dialog__content--active {
  background: rgba(0, 0, 0, 0.35);
  z-index: var(--z-modal) !important;
}

.send-dialog .v-card__text {
  width: auto;
  font-size: 16px;
  line-height: 18px;
  margin-top: 15px;
  font-weight: 300;
  padding: 5px 20px 20px 20px;
  text-align: left;
}

.send-dialog .headline {
  font-family: proxima-nova !important;
  font-size: 18px !important;
  line-height: 24px !important;
  font-weight: 600;
  padding: 20px 20px 10px 20px;
  text-align: left;
}

.send-dialog.v-dialog {
  border-top: 4px solid #35b2f0;
  width: 100%;
}

.send-dialog .v-card__actions {
  padding: 5px 20px 10px 20px;
}

.send-dialog .buttons {
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
}

.send-dialog button {
  width: 100%;
  margin-bottom: 10px;
}

.slide-up .close-slide-up.icon {
  cursor: pointer;
  pointer-events: all !important;
  margin-right: 0;
}

.transfer-amount {
  display: flex;
  flex-direction: column;
}

.share-list {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.share-list h3 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: 16px;
  line-height: 18px;
}

.faq {
  display: flex;
  justify-content: center;
  .faqContent {
    text-align: left;
    width: 850px;
    height: 100vh;
    padding: 15px;
    overflow-y: scroll;
    li {
      margin-left: 30px;
    }
  }
}

.divider {
  width: 2px;
  margin: 6px 0;
  background: #bbbcbc;
}

.transfer-display-item {
  flex: 0 1 auto;
  width: 100%;
  max-width: 330px;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100%;

  &.full-width {
    max-width: 100%;
  }
}

.transfer-display-info-container {
  flex: 0 1 auto;
  width: 100%;
  margin: 2em;
  text-align: center;
}

.transfer-display-search {
  text-align: left;
  margin: 0 auto auto auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-top: 20px;
}

.justifyContentCenter {
  justify-content: center;
}

.qual-qty {
  width: 60px;
}

@keyframes fadeIn {
  from {
    visibility: hidden;
  }

  to {
    visibility: visible;
  }
}

@keyframes fadeOut {
  from {
    visibility: visible;
  }

  to {
    visibility: hidden;
  }
}

@keyframes slideUp {
  from {
    top: 100%;
    max-height: 0;
  }

  to {
    top: 20%;
    max-height: 100%;
  }
}

@keyframes slideDown {
  from {
    top: 20%;
    max-height: 100%;
  }

  to {
    top: 100%;
    max-height: 0;
  }
}

@media (max-width: 1023px) {
  .slide-up section.share-product.open {
    top: 0;
    height: 100%;
    max-height: 100%;
  }
  .slide-up .slide-up-content {
    height: 100%;
  }

  @keyframes slideUp {
    from {
      top: 100%;
      max-height: 0;
    }

    to {
      top: 0;
      max-height: 100%;
    }
  }

  @keyframes slideDown {
    from {
      top: 0;
      max-height: 100%;
    }

    to {
      top: 100%;
      max-height: 0;
    }
  }
}

@media (max-width: 767px) {
  .send-content {
    flex-direction: column;
    align-items: center;
  }
  .divider {
    display: none;
  }
  .transfer-items-information-wrapper {
    display: none;
  }
}

@media (max-width: 749px) {
  #qualificationsView .other-markets {
    padding: 10px 20px;
  }
  .send-content {
    flex-wrap: wrap;
  }
}

@media screen and (orientation: landscape) and (max-height: 450px) {
  .slide-up .slide-up-content {
    padding: 20px;
    height: 100%;
  }
  .scrollable {
    height: calc(100% - 50px);
  }
  .scrollable.select-product {
    height: calc(100% - 80px);
  }
  .action-buttons {
    bottom: 0;
  }
}

@media (max-width: 450px) {
  .slide-up .slide-up-content {
    height: 100%;
  }
  .scrollable.select-product {
    height: calc(100% - 50px);
  }
  .action-buttons {
    width: calc(100% - 20px);
    box-sizing: border-box;
    bottom: 0px;
    padding: 10px 0 15px;
  }
  .action-buttons button {
    width: 100%;
    margin-top: 10px;
  }
  #mainContainer {
    padding: 0px;
  }
  .reserved-4-u {
    margin: 0 auto 10px;
    width: calc(100% - 40px);
  }
}

@media (max-width: 320px) {
  .slide-up .slide-up-content {
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media (max-width: 375px) {
  #qualificationsView {
    padding-top: 15px;
    padding-bottom: 0;
  }
  .transfer-display-info-container {
    display: none;
  }
}

@media (max-width: 545px) {
  #qualificationsView .other-markets {
    border-left: 8px solid var(--notice-color);
    border-top: none;
    padding-top: 20px;
    margin-bottom: 40px;
    max-width: 90%;
  }
  #qualificationsView .other-markets .content > div.country-dropdown {
    display: block;
  }
  #qualificationsView .other-markets .content {
    flex-direction: column;
  }
  #qualificationsView .other-markets .content,
  #qualificationsView .other-markets .content > div {
    width: 100%;
  }
  #qualificationsView .other-markets .content > div:nth-child(2) {
    margin-bottom: 10px;
  }
  .transfer-items-information-wrapper {
    display: none;
  }
  .divider {
    display: none;
  }
}

@media (max-width: 480px) {
  .scrollable {
    max-height: calc(100% - 230px);
    min-height: 400px;
  }
}

@media (min-width: 480px) {
  .slide-up-content {
    height: 100%;
  }
  .action-buttons {
    width: 400px;
    max-width: 100%;
    padding: 10px 0 15px 0;
  }
  .action-buttons button {
    margin-top: 10px;
  }
  #qualificationsView header p {
    height: auto;
  }
}

@media (min-width: 1024px) {
  #qualificationsView header h2 {
    font-size: 28px;
    line-height: 40px;
  }
  #qualificationsView header p,
  #qualificationsView header .reserved-4-u {
    font-size: 16px;
  }
  .slide-up .slide-up-content {
    header {
      div, h2, p {
        max-width: 850px;
        margin-left: auto;
        margin-right: auto;
      }
      div {
        margin-bottom: 20px;
      }
    }
    .send-content {
      max-width: 850px;
      margin: 0 auto;
    }
  }
  .send-content {
    width: 100%;
  }
  // .scrollable {
  //   overflow: visible;
  // }
  .share-list h3 {
    margin-top: -20px;
  }
  .action-buttons button {
    padding: 13px 40px;
  }
}
</style>
